export enum VestmentCategory {
  Chasuble = 'chasuble',
  Alb = 'alb',
  Stole = 'stole',
  Mitre = 'mitre',
}
